import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import CustomButton from '../CustomButton/CustomButton';

import { SummaryPos } from './index';

class Summary extends Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        schedulerData: PropTypes.object.isRequired,
        summary: PropTypes.object.isRequired,
        left: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
    };

    render() {
        const {
            summary, left, width, schedulerData, click
        } = this.props;
        const { config } = schedulerData;
        let color = config.summaryColor;
        if (summary.color != undefined) color = summary.color;
        let textAlign = 'center';
        if (config.summaryPos === SummaryPos.TopRight || config.summaryPos === SummaryPos.BottomRight) textAlign = 'right';
        else if (config.summaryPos === SummaryPos.TopLeft || config.summaryPos === SummaryPos.BottomLeft) textAlign = 'left';
        let style = { height: 25 };  // given fixed due to last row height if want to revert set height: config.eventItemHeight
        if (summary.fontSize != undefined) style = { ...style, fontSize: summary.fontSize };

        return (
            <span className="timeline-event header2-text add-more-button" style={{ left, width, bottom: -10 }}>
                <div style={style} onClick={() => click()}>
                    <CustomButton roundSmaller>
                        <i className="fas fa-plus"></i>
                    </CustomButton>
                </div>
            </span>
        );
    }
}

export default Summary;
